import { GetterTree } from 'vuex';
import { ILoginStore } from '../../../shared/store/shared.types';
import { IVerificationState } from './verification.types';

const verificationGetters: GetterTree<IVerificationState, ILoginStore> = {
  networkError(state): string {
    return state.networkError || '';
  },
  sykFieldInfo: state => state.sykFieldInfo,
};

export default verificationGetters;
